import {
  ArrowRightAlt,
  Class,
  Clear,
  DoneOutline,
  KeyboardBackspace,
  Publish,
  Stars,
} from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import React, { useContext } from "react";
import { toast } from "react-toastify";
import { ThemeContext } from "../../context/theme/ThemeContext";
import language from "../../i18n/english.json";
import { errorMessage } from "../../utils/notification";
import { checkAnswerWithScore, checkCorrect, sumCorrectTotal, sumQuestionTotal, totalCorrectScore } from "../../utils/sort";

let arrayDat = [];
function Quiz(props) {
  const { theme, changeTheme } = useContext(ThemeContext);
  const [index, setIndex] = React.useState(0);
  const [start, setStart] = React.useState(0);
  const [input, setInput] = React.useState({});
  const [result, setResult] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  //   const [arrayDat, setArrayDat] = React.useState([]);
  const { items, loading, submitQuiz, quiz_submit, total_score, intro, nextLecture } = props;

  const handleSingleInput = (label, e) => {
    var val = e.target.value;
    setInput({ ...input, [label]: val });
  };


  const handleArrayInput = (label, e) => {
    var val = e.target.value;
    let index = arrayDat.indexOf(val);
    if (index > -1) {
      arrayDat.splice(index, 1);
    } else {
      arrayDat.push(val);
    }
    setInput({ ...input, [label]: arrayDat });
  };

  const forwardQuiz = (req, id) => {
    console.log(id)
    if (req == 1 && !input['response_' + id]) {
      errorMessage(toast, "Question is required");
      return false;
    }
    let length = items?.total_quiz.length - 1;
    if (index < length) {
      setIndex(index + 1);
      arrayDat = [];
    }
  };
  const backQuiz = () => {
    if (index != 0) {
      setIndex(index - 1);
      arrayDat = [];
    }
  };



  React.useEffect(() => {
    if (quiz_submit) {
      quiz_submit['total_score'] = total_score;
      setResult(quiz_submit);
      setIndex(items?.total_quiz.length);
    }
  }, [quiz_submit]);

  const preSubmitQuiz = async () => {
    setLoader(true);
    let resp = await submitQuiz(input);
    if (resp?.remark) {
      setResult(resp);
      setIndex(index + 1);
    } else {
    }
    setLoader(false);
  };

  const retryQuiz = () => {
    setResult(null);
    setIndex(0)
  }

  return (
    <div>
      {!result?.remark && (
        <section id="" className="quizz-intro-section learn-section bg-white pt-0 md:pt-10 md: md:bg-inherit">
          <div className="container mpi-0">
            <div className="question-content-wrap">
              <div className="row">
                <div className="col-md-8 mpi-0">
                  {start == 0 &&
                    <div className="question-content">
                      <h4 className="md">Introduction</h4>
                      <p dangerouslySetInnerHTML={{
                        __html: intro,
                      }}></p>
                      <div className="form-action">
                        <button onClick={() => setStart(1)} defaultValue="Start Quiz" className="mc-btn btn-style-1" >Start Quiz</button>
                        <span className="total-time"></span>
                      </div>
                    </div>}
                  {start != 0 && items?.total_quiz[index] && index < items?.total_quiz.length && (

                    <div className="question-content">
                      <h4 className="sm">Question ({index + 1}) - {items?.total_quiz[index].type === "single" ? "Single choice" : "Multiple choice"} ({items?.total_quiz[index]?.is_required == 1 ? 'required' : ''})</h4>
                      <p>{items?.total_quiz[index].title} </p>
                      <div className="answer">
                        <h4 className="sm">Answer</h4>
                        <ul className="answer-list">
                          {items?.total_quiz[index].options.map((option, ind) => {
                            if (items?.total_quiz[index].type === "single") {
                              return (<li>
                                <input
                                  type="radio"
                                  id={"quizOption" + option.id}
                                  name={"response_" + items?.total_quiz[index].id}
                                  value={option.id}
                                  checked={
                                    input[
                                      "response_" + items?.total_quiz[index].id
                                    ] &&
                                      input[
                                      "response_" + items?.total_quiz[index].id
                                      ] == option.id
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    handleSingleInput(
                                      "response_" + items?.total_quiz[index].id,
                                      e
                                    )
                                  }
                                />
                                <label htmlFor={"quizOption" + option.id}>
                                  <i className="icon icon_radio" />
                                  {option?.title}
                                </label>
                              </li>
                              )
                            }
                            else {
                              return (<li>
                                <input type="radio"
                                  id={"quizOption" + option.id}
                                  name={"response_" + option.id}
                                  value={option.id}
                                  checked={
                                    input[
                                      "response_" + items?.total_quiz[index].id
                                    ] &&
                                      input[
                                        "response_" + items?.total_quiz[index].id
                                      ].indexOf(JSON.stringify(option.id)) > -1
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    handleArrayInput(
                                      "response_" + items?.total_quiz[index].id,
                                      e
                                    )
                                  }
                                />
                                <label htmlFor={"quizOption" + option.id}>
                                  <i className="icon icon_radio" />
                                  {option?.title}
                                </label>
                              </li>
                              )
                            }
                          })}
                        </ul>
                      </div>
                      <div className="">
                        <a onClick={backQuiz} className="mc-btn cursor-pointer btn-style-6">Previous</a>
                        {index > items?.total_quiz.length - 1 ||
                          (index != items?.total_quiz.length - 1 && (
                            <a disabled={index == items?.total_quiz.length ? true : false}
                              onClick={() => forwardQuiz(items?.total_quiz[index]?.is_required, items?.total_quiz[index].id)} className="mc-btn cursor-pointer btn-style-6">Next</a>))}
                        {index > items?.total_quiz.length - 1 ||
                          (index == items?.total_quiz.length - 1 && (
                            <a
                              onClick={() => preSubmitQuiz()}
                              disabled={loading}
                              className="mc-btn cursor-pointer btn-style-6"
                            >
                              {loading && <CircularProgress sx={{ color: "white" }} />}
                              {!loading && (
                                <>
                                  <Publish /> Submit Quiz
                                  <i className="bx bx-right-arrow-alt"></i>
                                </>
                              )}
                            </a>
                          ))}
                      </div>

                    </div>
                  )}

                </div>

                {/* <div className="col-md-4 col-sm-12">
                  <aside className="question-sidebar">
                    <div className="score-sb">
                      <h4 className="title-sb sm bold">Total score<span>{items?.total_quiz?.reduce((a, b) => a + b.point, 0)}</span></h4>
                      <ul>
                        {items?.total_quiz?.map((item, indexer) => (
                          <li className={index == indexer ? "active" : ""}><i className="icon" />Question {indexer + 1}<span>{item?.point}</span></li>
                        ))}
                      </ul>
                    </div>
                  </aside>
                </div> */}
              </div>
            </div>
          </div>
        </section>)}
      {result?.remark && index >= items?.total_quiz.length && (
        <section id="" className="quizz-intro-section learn-section bg-white pt-0 md:pt-10 md: md:bg-inherit">
          <div className="container mpi-0">
            <div className="question-content-wrap">
              <div className="row">
                <div className="col-md-8 mpi-0">
                  <div className="question-content">
                    <h4 className="sm">You got {sumCorrectTotal(result?.remark,)}/{items?.total_quiz.length} Questions right</h4>
                    <table className="table-question">
                      <thead>
                        <tr>
                          <th colSpan={2}>Correction</th>
                          <th className="right-answer">% Right Answer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items?.total_quiz?.map((item, ind) => {
                          return (
                            <tr key={ind}>
                              <td />
                              <td className="td-quest">{ind + 1}.{item?.title}.</td>
                              <td className="td-right-answer">
                                {checkCorrect(result?.remark, item?.id) && <span className="icon mdi1x text-green-500 mdi mdi-check"></span>}
                                {!checkCorrect(result?.remark, item?.id) && <span className="icon mdi1x text-red-800 mdi mdi-close"></span>}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                    <div className="form-action">
                      {result?.attempt < items?.attempt &&
                        <button onClick={retryQuiz} defaultValue="Redo quiz" className="mc-btn text-white btn-style-6">Redo Quiz</button>}
                      <button onClick={nextLecture} defaultValue="Next Unit" className="mc-btn text-white btn-style-6" >Next Lecture</button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <aside className="question-sidebared">
                    <div className="score-sb">
                      <h4 className="black sm bold">Total score<span className="ml-4">{totalCorrectScore(result?.remark)}</span></h4>
                      <ul>
                        {items?.total_quiz?.map((item, ind) => {
                          if (checkAnswerWithScore(result?.remark, item?.id) && checkAnswerWithScore(result?.remark, item?.id)['is_correct'] == 1) {
                            var data = checkAnswerWithScore(result?.remark, item?.id);
                            return (
                              <li className="active"><i className="icon" />Question {ind + 1}<span>{data && data['score'] ? data['score'] : "0"}</span></li>
                            )
                          }
                          else {
                            return (
                              <li className="err"><i className="icon" />Question {ind + 1}<span>0</span></li>
                            )
                          }
                        })}
                        {/* <li className="err"><i className="icon" />Question 2<span>20</span></li>
                        <li className="active"><i className="icon" />Question 3<span>20</span></li>
                        <li className="active"><i className="icon" />Question 4<span>20</span></li>
                        <li className="active"><i className="icon" />Question 5<span>20</span></li> */}
                      </ul>
                    </div>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Quiz;
